import React from 'react'
import { type PricingProduct } from '../types/pricing.types'
import { type HostSettings } from '../../common/js/webshop-product-utility';

import styles from '../styles/host-select.module.css'
import HostArray from '../../common/components/HostArray';

type Props = {
    product: PricingProduct,
    selected: string,
    onChange: Function
}

export default function HostSelection({product, selected, onChange}: Props) {
    const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const host = event.currentTarget.value;
        onChange(host);
    }

    if (product.hosts.length < 2){
        return <fieldset className={styles.hostSelect + ' hidden'}></fieldset>
    }
    
    const options: React.JSX.Element[] = [];
    product.hosts.forEach((h: HostSettings, i: number) => {
        options.push(
            <div key={h.name} className={styles.hostOption}>
                <input id={`host-${i}`} type="radio" name="host" value={h.name} checked={selected == h.name} onChange={handleOptionChange} />
                <label htmlFor={`host-${i}`}>
                    {h.icons.length > 0 && (
                        <HostArray iconUrls={h.icons} iconSize={46} gapSize={32} />
                    )}
                    <div className={styles.hostLabelContainer}>
                        <h6 className={styles.hostLabel}>{h.description}</h6>
                    </div>
                </label>
            </div>
        )
    })

    return (
        <fieldset className={styles.hostSelect}>
            {options}
        </fieldset>
    )
}